// Third-party
import React, { Component } from 'react';
import { Route, RouteComponentProps, withRouter, Redirect, Switch } from 'react-router';
import { connect } from 'react-redux';

// Components
import EnterpriseGroupSettings from './LegacyEnterpriseGroupSettings';

// Utils
import { ReduxState } from '../../../../redux/modules/types';

import { saveEnterpriseGroupInfos } from '../../../../redux/modules/enterprise/admin/groups';
import { FolderTabs, Breadcrumb } from '../../../components/navigation';
import { formatMessage } from '../../../../utils/i18n';
import EnterpriseMembers from '../enterprise/enterprise-members/EnterpriseMembers';
import EnterprisePortfolios from '../enterprise/EnterprisePortfolios';
import { PERMISSIONS, userHasPermission, userHasPermissionEnabled } from '../../../../utils/permissions';
import EnterpriseGroupInfos from '@/types/enterprise-group-infos';
import EnterpriseInfos from '@/types/enterprise-infos';
import EnterpriseAdminGroup from '@/types/enterprise-admin-group';
import User from '@/types/user';

type State = {};

type DispatchProps = {
  saveEnterpriseGroupInfos: (groupId: string, infos: EnterpriseGroupInfos) => Promise<EnterpriseGroupInfos>;
};

type StateProps = {
  group?: EnterpriseAdminGroup;
};

type ParentProps = {
  user: User;
};

type RouteProps = RouteComponentProps<{ id: string }>;

type Props = StateProps & ParentProps & DispatchProps & RouteProps;

class EnterpriseGroupDetails extends Component<Props, State> {
  readonly state: State = {};

  onSaveInfo = (infos: EnterpriseInfos) => {
    const { group } = this.props;

    if (!group) {
      return Promise.reject();
    }

    return this.props.saveEnterpriseGroupInfos(group._id, infos);
  };

  render() {
    const {
      group,
      user,
      match: { url },
    } = this.props;

    if (!group) {
      return null;
    }

    const memberAdmin = userHasPermissionEnabled(
      user,
      PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MEMBERS,
      PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MEMBERS_ADD,
      PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MEMBERS_REMOVE,
    );
    const modelAdmin = userHasPermission(user, PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MODELS);
    const redirect = memberAdmin ? 'members' : 'models';

    const tabs = [
      {
        label: formatMessage('Admin.Enterprise.TeamMembers'),
        value: `${url}/members`,
        disabled: !memberAdmin,
      },
      {
        label: formatMessage('Admin.Enterprise.PortfoliosTitle'),
        value: `${url}/models`,
        disabled: !modelAdmin,
      },
    ];

    const breadcrumbs = [
      {
        value: formatMessage('Admin.Enterprise.Groups.Title'),
        redirect: '/admin/groups',
      },
      {
        value: group.name,
      },
    ];

    return (
      <div className="enterprise-group-details">
        <Breadcrumb replace items={breadcrumbs} />

        <EnterpriseGroupSettings onSave={this.onSaveInfo} group={group} user={user} />

        <FolderTabs items={tabs} />

        <div className="tab-content">
          <Switch>
            {memberAdmin && (
              <Route path={`${url}/members`}>
                <EnterpriseMembers group={group} />
              </Route>
            )}
            {modelAdmin && (
              <Route path={`${url}/models`}>
                <EnterprisePortfolios user={user} group={group} />
              </Route>
            )}

            <Redirect to={`${url}/${redirect}`} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxState, ownProps: RouteProps) => {
  const groups = state.enterprise.admin ? state.enterprise.admin.groups : [];
  return {
    group: groups.find(g => g._id === ownProps.match.params.id),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    saveEnterpriseGroupInfos,
  })(EnterpriseGroupDetails),
);
